"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IControlType = void 0;
var IControlType;
(function (IControlType) {
    IControlType["Incline"] = "incline";
    IControlType["Mps"] = "mps";
    IControlType["Resistance"] = "resistance";
    IControlType["Gear"] = "gear";
    IControlType["Rpm"] = "rpm";
    IControlType["Watts"] = "watts";
    IControlType["Calories"] = "calories";
    IControlType["Zone"] = "zone";
    IControlType["Spm"] = "spm";
    IControlType["RelativeResistance"] = "relativeResistance";
})(IControlType || (exports.IControlType = IControlType = {}));
//# sourceMappingURL=control-type.js.map